<template>
  <footer class="app-footer">
    <span class="app-footer-copy">© 2026 CrossFit Event Scanner</span>
    <nav class="app-footer-links">
      <nuxt-link to="/">Événements</nuxt-link>
      <nuxt-link to="/calendar">Calendrier</nuxt-link>
      <nuxt-link to="/map">Carte</nuxt-link>
      <nuxt-link to="/mentions-legales">Mentions légales</nuxt-link>
      <nuxt-link to="/confidentialite">Confidentialité</nuxt-link>
      <button @click="reset">Cookies</button>
    </nav>
  </footer>
</template>

<script setup lang="ts">
const { reset } = useCookieConsent();
</script>
